import { Group } from '@gripp/shared-logic';
import { Colors, colors, GroupSelector, ResetIcon, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text, View } from 'react-native';

type MainProps = {
  selectedGroups: Group[];
  onGroupsChange: (groups: Group[]) => void;
  onCreateGroup: (name: string) => Promise<Group>;
  onOpenPicker: () => void;
};

type HeaderActionsProps = {
  onReset: () => void;
};

export const AssetsSelectionPanelMain = ({
  selectedGroups,
  onGroupsChange,
  onCreateGroup,
  onOpenPicker,
}: MainProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Text style={[tokens.typography.label.largeEmphasised, styles.label]}>
        {t('asset.groups')}
      </Text>
      <GroupSelector
        selectedGroups={selectedGroups}
        availableGroups={[]}
        onGroupsChange={onGroupsChange}
        onCreateGroup={onCreateGroup}
        onSelectorEdit={onOpenPicker}
      />
    </View>
  );
};

export const AssetsSelectionPanelHeaderActions = ({
  onReset,
}: HeaderActionsProps) => (
  <Pressable onPress={onReset} style={styles.headerButton}>
    <ResetIcon size={20} color={Colors.role.textStrong} />
  </Pressable>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 8,
  },
  label: {
    color: Colors.role.textStrong,
  },
  headerButton: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
